import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import {when} from 'lit/directives/when.js';
import store from '../../store';
import {getProductData} from '../../util/getProductData';
import {isSatisfied} from '../../util/values';
import {selectFeatureModelCompletionPercentage} from '../../selectors';


@customElement('solar-new-specsheet')
export class SolarNewSpecsheet extends connect(store)(LitElement) {

	static styles = [
		//cssProperties,
		css`
		:host {
			font-family: var(--font-family-light);
		}
		`
	];
	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}

	stateChanged(state) {
		this.state = state;
		this.featureModelIsSatisfied = selectFeatureModelCompletionPercentage(state) >= 100; // state.decisions.data.isSatisfied;
	}

	featureModelCompletionPercentage() {
		if (this.features) {
			const visibleCount = this.features
				.filter(feature => getProductData(feature.variableId, this.productData)?.isVisible)
				.length ?? 100;
			const satisfiedCount = this.features
				.filter(feature => getProductData(feature.variableId, this.productData)?.isVisible && isSatisfied(feature.variableId, this.decisions))
				.length ?? 0;

			return Math.round((satisfiedCount / visibleCount * 100));
		} else {
			return 0;
		}
	}

	render() {
		return html`
			<family-overview-page>
				<family-overview></family-overview>
			</family-overview-page>
			<family-overview-page>
				<model-overview></model-overview>
			</family-overview-page>
			${when(this.featureModelIsSatisfied, () => html`
				<shared-specsheet-page>
					<shared-technical-data-page></shared-technical-data-page>
				</shared-specsheet-page>
				<shared-specsheet-page>
					<shared-tender-text-page></shared-tender-text-page>
				</shared-specsheet-page>
				<shared-specsheet-page>
					<solar-light-engine></solar-light-engine>
				</shared-specsheet-page>
			`)}
		`;
		}
	}
